import React, { PureComponent } from 'react';
import injectSheet from 'react-jss';
import { Card, Typography, Row, Col, Table, Button, message, Icon } from 'antd';
import numberWithSpaces from 'src/utils';
import moment from 'moment';
import styles from './styles';
import CONSTANTS from 'src/constants';
const { Title, Text } = Typography;
import { getCompanySpent, getListCompanies, getCompanieInfo } from 'src/redux/actions/companies';
import { affectCreditWithInvoice } from 'src/redux/actions/affectCreditWithInvoice.js';
//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
	return {
		store: {
			amountInfo: state.dashboard.amountInfo
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				getCompanySpent,
				getListCompanies,
				getCompanieInfo,
				affectCreditWithInvoice
			},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class CompanySpent extends PureComponent {
	state = {
		dataCompanyInvoice: [],
		dataFooter: [],
		amountTTC: 0,
		amountHC: 0,
		amountPass: 0,
		totalAmountTTCUnpaid: 0,
		affectVisible: false,
		companyDetails: [],
		companyData: [],
		companyListActivated: [],
		loadingCreditAffection: false,
		companyCreditAffection: []
	};

	componentDidMount() {
		this.getCompanySpent();
		this.getListCompany()
	}

	getCompanySpent = (params) => {
		let ttc = 0;
		let hc = 0;
		let com = 0;
		let totalAmountTTCUnpaid = 0;
		let date = new Date();
		const payload = {
		}

		this.props.action.getCompanySpent(
			payload,
			res => {
				if (res.length > 0) {
					res.forEach(e => {
						hc += parseInt(e.total_pass_hc);
						com += parseInt(e.total_ttc - e.total_pass_hc);
						ttc += parseInt(e.total_ttc);
						e.status == 0 && (totalAmountTTCUnpaid += parseInt(e.total_ttc));
					});
					this.setState({ dataCompanyInvoice: res, amountTTC: ttc, amountHC: hc, amountPass: com, totalAmountTTCUnpaid: totalAmountTTCUnpaid })
				}
			},
		);
	}

	findNumberWithSpaces = val => {
		return <span>{(val ? numberWithSpaces(val) : 0) + '  ' + CONSTANTS.CURRENCY}</span>
	}

	toggleState = state => {
		this.setState(state);
	};

	resetState = () => {
		this.setState({ companyDetails: [], companyCreditAffection: [], affectVisible: false });
	}

	getListCompany = (payload = {}) => {
		this.setState({ loadingCreditAffection: true });
		this.props.action.getListCompanies(
			payload,
			res => {
				this.setState({
					loadingCreditAffection: false,
					companyData: res['hydra:member'],
					total: res['hydra:totalItems']
				});
			},
			() => this.setState({ loadingCreditAffection: false })
		);
	};

	onChangeCompany = (e) => {
		this.toggleState({ companyCreditAffection: e.companyCreditAffection })
		this.setState({ loadingCreditAffection: true });
		const payload = { id: e.companyCreditAffection };

		this.props.action.getCompanieInfo(
			payload,
			(res) => {
				this.setState(
					{
						loadingCreditAffection: false,
						companyDetails: res,
					}
				);
			},
			() => {
				this.setState({ loadingCreditAffection: false });
			}
		);
	}

	handleAffectCreditWithGenerateInvoice = payload => {
		this.setState(
			{ loadingCreditAffection: true },
			() => {
				this.props.action.affectCreditWithInvoice(
					payload,
					(res) => {
						if (res && res.error) {
							this.setState({ loadingCreditAffection: false, companyDetails: [] });
							message.error('Une erreur est survenue');
						} else {
							this.setState(
								{ affectVisible: false, loadingCreditAffection: false, companyDetails: [] },
								async () => {
									message.success('Crédit envoyé avec succès');
								});
							this.getCompanySpent();
						}
					},
					() => this.setState({ affectVisible: false, loadingCreditAffection: false, companyDetails: [] })
				);
			}
		);
	}

	render() {
		const {
			classes,
			store: {
				amountInfo: { data = {} }
			}
		} = this.props;
		const { dataCompanyInvoice, amountTTC } = this.state;
		const date = new Date();
		const columns = [
			{
				title: 'Nom société',
				dataIndex: 'company_name',
				key: 'company_name',
			},
			{
				title: 'Total Pass (Hors commission)',
				dataIndex: 'total_pass_hc',
				key: 'total_pass_hc',
				align: 'right',
				sorter: (a, b) => a.total_pass_hc - b.total_pass_hc,
				render: (a, b) => {
					return <Text strong style={{ color: "#00c68e" }}>{this.findNumberWithSpaces(a)}</Text>
				}
			},
			{
				title: 'Total commission',
				dataIndex: 'total_commission',
				key: 'total_commission',
				align: 'right',
				sorter: (a, b) => (a.total_ttc - a.total_pass_hc) - (b.total_ttc - b.total_pass_hc),
				render: (a, b) => {
					return <Text strong style={{ color: "#00c68e" }}>{this.findNumberWithSpaces(b.total_ttc - b.total_pass_hc)}</Text>
				}
			},
			{
				title: 'Total imapyé TTC',
				dataIndex: 'total_unpaid_ttc',
				key: 'total_unpaid_ttc',
				align: 'right',
				sorter: (a, b) => a.total_unpaid_ttc - b.total_unpaid_ttc,
				render: (a, b) => {
					return <Text strong style={{ color: "#00c68e" }}>{this.findNumberWithSpaces(a)}</Text>
				}
			},
			{
				title: 'Ratio de consommation',
				dataIndex: 'ratio',
				key: 'ratio',
				align: 'center',
				sorter: (a, b) => a.ratio - b.ratio,
				render: (data) => {
					return (
						<Text strong style={{ color: "#00c68e" }}>{data ? (data + '%') : '/'}</Text>
					)
				}
			}
		]

		return (
			<>
				<Card bordered={true}>
					<Title type="secondary" level={4}>

						<Row type="flex" justify="space-between" align="middle">
							<Col>
								Récapitulatif des commandes affectées depuis le 1er janvier
							</Col>
							<Col>
								{/* <Button
									onClick={() => this.toggleState({ affectVisible: true })}
									icon="dollar"
									type="link"
								>
									Affecter des crédits
								</Button> */}
							</Col>
						</Row>
					</Title>
					<Table
						locale={{ emptyText: "Aucune données" }}
						columns={columns}
						dataSource={dataCompanyInvoice}
						pagination={false}
						scroll={{ y: '40vh' }}
						footer={() => (
							<table>
								<tr>
									<td><Text>Total</Text></td>
									<td align='right'><Text strong style={{ color: "#00c68e" }}>{this.findNumberWithSpaces(this.state.amountHC)}</Text></td>
									<td align='right'><Text strong style={{ color: "#00c68e" }}>{this.findNumberWithSpaces(this.state.amountPass)}</Text></td>
									<td align='right'><Text strong style={{ color: "#00c68e" }}>{this.findNumberWithSpaces(this.state.amountTTC)}</Text></td>
									<td></td>
								</tr>
							</table>
						)}
					>
					</Table>
				</Card>
			</>
		);
	}
}
